import * as React from "react";
import { FunctionComponent } from "react";
import { ITranslationFunc } from "../../i18n";
import { useTranslations } from "../../i18n/useTranslations";
import { useMenu } from "../../Menu/useMenu";
import { useShoppingList } from "../../shoppingList/useShoppingList";
import { hrefToDashes } from "../../utils";

export const ShoppingListButton = () => {
	const { t } = useTranslations();
	const { numOfItems } = useShoppingList();

	const { shoppingList: item } = useMenu().items;

	return (
		<div className="elm-w-10 elm-h-10 elm-rounded-full elm-cursor-pointer elm-pointer-events-auto elm-transition lg:hover:elm-bg-dd-blue-100">
			<a
				className="focus:elm-outline-none elm-block elm-rounded-full"
				tabIndex={0}
				data-track-label={`link:${hrefToDashes(item.href)}`}
				href={item.href}
				target="_parent"
				title={t("Shopping List")}
				aria-label={t("Shopping List")}
			>
				{numOfItems === 0 ? (
					<RegularState />
				) : (
					<WithNotificationState t={t}>
						<RegularState />
					</WithNotificationState>
				)}
			</a>
		</div>
	);
};

function RegularState() {
	return (
		<span className="elm-w-10 elm-h-10 elm-flex elm-justify-center elm-items-center elm-pointer-events-none">
			<svg
				xmlns="http://www.w3.org/2000/svg"
				className="elm-block elm-stroke-current elm-text-dd-blue-900"
				width="23"
				height="23"
				viewBox="0 0 24 23"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.6"
				strokeLinecap="round"
				strokeLinejoin="round"
			>
				<circle cx="9" cy="21" r="1" />
				<circle cx="20" cy="21" r="1" />
				<path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
			</svg>
		</span>
	);
}

type WithNotificationStateProps = {
	t: ITranslationFunc;
	children?: React.ReactNode;
};

const WithNotificationState: FunctionComponent<WithNotificationStateProps> = ({
	children,
	t,
}) => (
	<span
		aria-label={t("You have items in the Shopping List")}
		className="elm-relative elm-pointer-events-none"
	>
		<span className="elm-absolute elm-bg-dd-pink-900 elm-w-2 elm-h-2 elm-right-1.5 elm-top-1.5 elm-rounded-full" />
		{children}
	</span>
);
